module.exports = __webpack_public_path__ + "static/media/mode16.9f385fcb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode16.gif
// module id = 1444
// module chunks = 110